import type { AttendanceDensity } from "./attendance-types";

/** Sticky identity column (name + id subtitle). */
export const NAME_COL_WIDTH = 128;

/** Abbreviated summary headers: P / ! / X / L */
export const SUMMARY_COL_WIDTH = 36;

export const HOURS_COL_WIDTH = 72;

/** Compact day cells — symbol only. */
export const DAY_COL_COMPACT = 30;

/** Times mode day cells — HH:mm–HH:mm needs more room. */
export const DAY_COL_TIMES = 80;

export type DayMeta = {
  day: number;
  weekday: number;
  weekdayLetter: string;
  isOff: boolean;
};

/** First letter of weekday for ultra-narrow headers (Sun→S …). */
export function weekdayLetterFromIndex(weekday: number): string {
  return ["S", "M", "T", "W", "T", "F", "S"][weekday] ?? "?";
}

/** Three-letter weekday for roomier calendars (Sun, Mon, …). */
export function weekdayShortFromIndex(weekday: number): string {
  return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"][weekday] ?? "?";
}

export function dayColumnWidth(density: AttendanceDensity): number {
  return density === "times" ? DAY_COL_TIMES : DAY_COL_COMPACT;
}

/** Sticky summary block width (right edge). Includes leave (L) column. */
export function summaryBlockWidth(includeLate: boolean): number {
  // P + ! + X + L(leave) + Hrs; optional Late
  const base = SUMMARY_COL_WIDTH * 4 + HOURS_COL_WIDTH;
  return includeLate ? base + SUMMARY_COL_WIDTH : base;
}

export function estimateGridMinWidth(params: {
  visibleDayCount: number;
  density: AttendanceDensity;
  includeLate: boolean;
}): number {
  return (
    NAME_COL_WIDTH +
    params.visibleDayCount * dayColumnWidth(params.density) +
    summaryBlockWidth(params.includeLate)
  );
}
